import React from 'react'
import { Modal, Button } from '@st-operations/uikit/src/v2'
import CustomField from '../NewCustomFields'
import './styles.scss'

const fields = [{ name: 'name' }, { name: 'field' }, { name: 'type' }]
const APA_CUSTOM_FIELD_SCHEMA = {
  name: {
    default: '',
    type: 'string',
  },
  field: {
    default: '',
    type: 'string',
  },
  type: {
    default: '',
    type: 'string',
    enum: ['String', 'Number'],
  },
}

const CustomFieldsModal = (props) => {
  const { isOpen, onClose, onChange, type, item, header } = props

  const onAdd = (value) => {
    if (value?.name && value?.field && value?.type) {
      const updatedFields = item[type]?.length ? [...item[type], value] : [value]
      onChange(updatedFields, type)
    }
  }

  const onRemove = (removeField) => {
    const filteredFields = item[type]?.filter(
      (existingField) => existingField.field !== removeField.field
    )
    onChange(filteredFields, type)
  }

  return (
    <Modal onClose={onClose} isOpen={isOpen} className="custom-fields-modal">
      <div>
        <h2>{header}</h2>
        <div className="custom-field-modal-content">
          <If condition={item[type]?.length > 0}>
            <For each="field" index="index" of={item[type]}>
              <CustomField
                key={index}
                type={type}
                isRemove={true}
                schema={APA_CUSTOM_FIELD_SCHEMA}
                fields={fields}
                field={field}
                onRemove={onRemove}
              />
            </For>
          </If>
          <CustomField
            type={type}
            isRemove={false}
            onAdd={onAdd}
            schema={APA_CUSTOM_FIELD_SCHEMA}
            fields={fields}
          />
          <Button style={{ width: '50%' }} size="small" onClick={onClose}>
            {' '}
            back to destination{' '}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default CustomFieldsModal
